import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import actions from '../constants';
import DictionaryConvertToastError from '../components/DictionaryConvertToastError';
import DictionaryConvertToast from '../components/DictionaryConvertToast';
import DatasetConvertToastError from '../components/DatasetConvertToastError';
import DatasetConvertToast from '../components/DatasetConvertToast';

export function* convertDatasetDictionariesToast({ datasetName }) {
  yield call(showToast, <DatasetConvertToast datasetName={datasetName} />);
}

export function* convertDatasetDictionariesErrorToast({ datasetName }) {
  yield call(showToast, <DatasetConvertToastError datasetName={datasetName} />);
}

export function* convertDictionaryDataToast({ dictionaryName, isNew }) {
  yield call(showToast, <DictionaryConvertToast dictionaryName={dictionaryName} isNew={isNew} />);
}

export function* convertDictionaryDataErrorToast({ dictionaryName, isNew }) {
  yield call(showToast, <DictionaryConvertToastError dictionaryName={dictionaryName} isNew={isNew} />);
}

export default function* datasetDataManagementToasts() {
  yield takeEvery(actions.CONVERT_DATASET_DATA_SUCCESS, convertDatasetDictionariesToast);
  yield takeEvery(actions.CONVERT_DATASET_DATA_ERROR, convertDatasetDictionariesErrorToast);
  yield takeEvery(actions.CONVERT_DICTIONARY_DATA_SUCCESS, convertDictionaryDataToast);
  yield takeEvery(actions.CONVERT_DICTIONARY_DATA_ERROR, convertDictionaryDataErrorToast);
}
